/* eslint-disable max-len */
import { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import ListGroup from 'react-bootstrap/ListGroup';
import ListGroupItem from 'react-bootstrap/ListGroupItem';
import moment from 'moment';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import * as actions from 'modules/notifications/push/actions';
import * as URL from '../../../lib/router/url';
import Can from '../../permissions/abilities/Can';
import Panel from '../../core/components/panel';
import { SimpleSelectInput } from '../../core/components/forms';
import { unixToDateTimeString } from '../../core/utils/date';

// interface PanelUserNotificationsProps {
//   loadingUserHistory?: boolean
//   userNotificationHistory?: unknown[]
//   getUserHistory?(...args: unknown[]): unknown
//   userNotificationDays?: number
// }

class PanelUserNotifications extends PureComponent<PanelUserNotificationsProps> {
  constructor(props) {
    super(props);
    this.state = {
      daysState: 10,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate() {
    this.loadData();
  }

  getTime(days) {
    return moment.utc().add(-days, 'd').format('X');
  }

  loadData = async () => {
    if ((!this.props.loadingUserHistory) && (this.props.userNotificationDays !== this.state.daysState)) {
      await this.props.getUserHistory({
        since: this.getTime(this.state.daysState),
        userNotificationDays: this.state.daysState,
      });
    }
  };

  convertTime = (dateTime) => {
    return (typeof (dateTime) === 'string')
      ? moment.utc(dateTime).local().format('DD.MM.YYYY HH:mm')
      : unixToDateTimeString(dateTime);
  };

  render() {
    const { loadingUserHistory, userNotificationHistory } = this.props;
    return (
      <Can do='available' on='show.notifications'>
        { can => (
          <Panel loading={ can && loadingUserHistory }>
            <section className='dashboard_panel no_right_margin'>
              <Row>
                <Col xs={ 8 }>
                  <h2 className='dashboard_title'>Последние уведомления</h2>
                </Col>
                <Col xs={ 4 }>
                  <div className='mx-3'>
                    <SimpleSelectInput
                      value={ this.state.daysState ?? 10 }
                      name='documentTypeString'
                      data={ [{ id: 3, value: 3 }, { id: 10, value: 10 }, { id: 30, value: 30 }] }
                      dataTitle='value'
                      dataValue='id'
                      placeholder='Период в днях'
                      onChange={ v => this.setState({ daysState: v.target.value }) }
                      required
                    />
                  </div>
                </Col>
              </Row>
              <div className='dashboard_scroll-block'>
                <ListGroup>
                  { userNotificationHistory?.map(notification => (
                    <ListGroupItem key={ notification.id }>
                      <span className='float-end'>
                        <strong>{ this.convertTime(notification.sendingAt) }</strong>
                      </span>

                      <div>
                        Текст: <Link to={ `${ URL.URL_ORDERS_VIEW_ONE }/${ notification.orderId }` }>{ notification.pushBody }</Link>
                      </div>
                      <div>
                        Время: <span><b>{ this.convertTime(notification.sendingAt) }</b></span>
                      </div>
                    </ListGroupItem>
                  )) }
                </ListGroup>
              </div>
            </section>
          </Panel>
        ) }
      </Can>
    );
  }
}

const mapStateToProps = state => ({
  userNotificationHistory: state.notifications?.userNotificationHistory,
  loadingUserHistory: state.notifications?.loadingUserHistory,
  userNotificationDays: state.notifications?.userNotificationDays,
});

const mapDispatchToProps = dispatch => ({
  getUserHistory: payload => dispatch(actions.getUserHistory(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelUserNotifications);
